export { default } from '#/containers/Products/Studio'
export { getServerSideProps } from '#/utils/page_wrapper'
